import styled from "styled-components";

export const StyledListItem = styled.li`
  color: #000;
  position: relative;
  text-decoration: none;

  &:before {
    content: "";
    inset: 0;
    position: absolute;
    transform: scaleX(0);
    transition: transform 0.5s ease-in-out;
    z-index: -1;
    border-radius: 10px;
  }

  &:hover::before {
    transform: scaleX(1);
  }
`;

export const StyledGridUl = styled.ul`
  display: grid;
  grid-template-columns: repeat(
    ${(props) => (props.rows.length < 3 ? "auto-fit" : "auto-fill")},
    minmax(450px, calc(100% / ${(props) => props.rowLength}))
  );
  //grid-template-columns: repeat(auto-fill, minmax(321px, 3fr));
  list-style-type: none;
  padding-left: 0px;
  align-items: center;
  justify-content: center;
  /* 📱 Mobil */
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
  }
`;
